import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getReportList } from '../../../slices/thunks';
import DeleteReportModal from './Delete/DeleteReport';
import AddEditReportModal from './Add_Edit/AddEditReportModal';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const ReportList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorReport = createSelector(
		state => state.Report,
		report => ({
			reportList: report.reportList,
			isLoadingList: report.isLoadingList,
			isReportSuccess: report.isReportSuccess,
			error: report.error,
			isAdding: report.isAdding,
			isAdded: report.isAdded,
			isAddError: report.isAddError,
			isUpdating: report.isUpdating,
			isUpdated: report.isUpdated,
			isUpdateError: report.isUpdateError,
			isDeleting: report.isDeleting,
			isDeleted: report.isDeleted,
			isDeleteError: report.isDeleteError,
		})
	);

	const { reportList, isLoadingList } = useSelector(		selectorReport	);

	useEffect(() => {
		dispatch(getReportList());
	}, []);

	const [dataReport, setDataReport] = useState({});
	const [isEdit, setIsEdit] = useState(false);	

	// Delete Report
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = report => {
		setDataReport(report);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = report => {
		setDataReport(report);
		handleToggleModal();
	};


	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'report',
				columnDefType: 'display',
				 size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const reportData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(reportData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const reportData =
														cellProps.row.original;
													handleClickDelete(reportData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link to={`/finance/report-view/${cellProps.row.original._id}`}>
												<i className={`${Icons.reports} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre del reporte', accessorKey: 'name',  size: 'auto' },
			{ header: 'Periodo', accessorKey: 'period',  size: 'auto' },
			{ header: 'Inicio', accessorKey: 'date_ini', dataType: 'date' },
			{ header: 'Término', accessorKey: 'date_end', dataType: 'date' },
			{ header: 'Descripción', accessorKey: 'description',  size: 'auto' },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataReport({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Reporte
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={reportList || []}
								isLoadingData={isLoadingList}
								nameFile={'reportes'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataReport({});
											handleToggleModal();
										},
										title: 'Crear Reporte'
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditReportModal
				dataReport={dataReport}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteReportModal
				dataReport={dataReport}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default ReportList;
